module.exports = __webpack_public_path__ + "static/media/cnet2.e6bdf66d.png";